import { Trans, useTranslation } from 'next-i18next';
import Button from '../button/Button';
const InfoBox = ({ location = 'priceList' }) => {
  const { t, i18n } = useTranslation(location);
  return (
    <div className='flex flex-col bg-[#1F1F1F] p-6 items-start'>
      <h4 className='text-white text-2xl font-semibold mb-6'>{t(`${location}.box.title`)}</h4>
      <p className='text-white mb-6'>
        <Trans i18nKey={t(`${location}.box.text`)}></Trans>
      </p>
      <Button text={t(`${location}.box.btn`)} link='#rezervace' style='yellow'></Button>
    </div>
  );
};

export default InfoBox;
